import { ChevronRight } from "lucide-react";
import { useDashboardStore } from "../store/dashboardStore";
import { cn } from "@/lib/utils";

interface BreadcrumbProps {
    /**
     * Variante visual. `light` (default) = breadcrumb em página clara
     * (cinza no branco). `dark` = breadcrumb dentro do hero escuro (branco
     * translúcido). Usado pra economizar uma linha — em vez de aparecer
     * fora do hero, fica no slot do kicker.
     */
    variant?: "light" | "dark";
}

export function Breadcrumb({ variant = "light" }: BreadcrumbProps) {
    const breadcrumbs = useDashboardStore((s) => s.breadcrumbs);
    const goToCrumb = useDashboardStore((s) => s.goToCrumb);

    const isDark = variant === "dark";

    return (
        <nav
            className={cn(
                "flex items-center gap-1.5 text-xs uppercase tracking-wider",
                isDark ? "text-white/60" : "text-gray-500"
            )}
        >
            {breadcrumbs.map((b, i) => {
                const isLast = i === breadcrumbs.length - 1;
                return (
                    <span key={i} className="flex items-center gap-1.5">
                        {i > 0 && (
                            <ChevronRight
                                className={cn(
                                    "w-3 h-3",
                                    isDark
                                        ? "text-white/30"
                                        : "text-gray-300"
                                )}
                            />
                        )}
                        {isLast ? (
                            <span
                                className={cn(
                                    "font-semibold",
                                    isDark ? "text-white" : "text-gray-900"
                                )}
                            >
                                {b.label}
                            </span>
                        ) : (
                            <button
                                onClick={() => goToCrumb(i)}
                                className={cn(
                                    "transition-colors",
                                    isDark
                                        ? "hover:text-white"
                                        : "hover:text-gray-900"
                                )}
                            >
                                {b.label}
                            </button>
                        )}
                    </span>
                );
            })}
        </nav>
    );
}
